export default "__VITE_ASSET__4f7a1ef6__"